import Vue  from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    menuItems: [
      { title: 'Home', to: '/', tooltip: 'KENDEDA main page' },
      { title: 'Dashboard', to: '/dashboard', tooltip: 'Interactive data analytics' },
      { title: 'Calendar', to: '/calendar', tooltip: 'Calendar for event composer' },
      { title: 'Energy/Water', to: '/rbs', tooltip: 'Time-wise vis. by sankey diagram' },
      { title: 'Kendeda Site', tooltip: 'Kendeda official site'},
      { title: 'Kendeda Digital Twin', to: '/kendedaDTW', tooltip: 'Interactive Energy Model of the Kendeda Building'},
    ],
    startDateInd: 0,
    endDateInd: 364,
    startDate: "01/01",
    endDate: "12/31",
    selectedTimes: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23],
    dataLoopOption: 0,
    building: {
      location: 'Atlanta, GA',
      usage: 'Standard',
      buildingType: 'Educational',
      grossArea: 25000, //sqft
    },
    water: {
      //for essential water related data
      toilet: 'Foam Flush Composting',
      faucet: 'Ultra High Efficiency',
      kFactors: {
        toilets: 1,
        faucets: 1,
      },
      cisternCapacity: 20000, //gallons
      currentLevel: 20000, //gallons
      historicalLevel: [], //gallons
      collectionRate: 0, //gpm
      consumptionRate: 200, //gpm
      meters: [
        //for keeping track of individual meters
        {
          id: 'WM-105',
          name: 'Total Domestic',
          currentReading: 0, //gpm
          pastData: [],
        },
        {
          id: 'WM-101',
          name: 'GT Station',
          currentReading: 0, //gpm
          pastData: [],
        }
      ],
    },
    energy: {
      //for essentail energy related data
      baselineSolarArraySize: 256,
      solarArraySize: 256,
      lightbulb: 'LED',
      hvac: 'VAV + Radiant Floors',
      windows: 'Single Pane',
      kFactors: {
        solarArraySize: 1,
        lightbulb: 1,
        hvac: 1,
        windows: 1,
      },
      collectionRate: 0, //kW
      consumptionRate: 0, //kW
      meters: [
        //for keeping track of individual meters
        {
          id: 'EM-107',
          name: 'Demand',
          currentReading: 0, //kW
          pastData: [],
        },
        {
          id: 'EM-102',
          name: 'PV',
          currentReading: 0, //kW
          pastData: [],
        }
      ],
    },
    weather: {
      //for weather data
      baseYear: 2017,
    },
    events: [
      //for event data
       {
         title: 'Company Event',
         details: 'Recruitment event for internships',
         date: '2019-03-30',
         people: '50',
         open: false
       },
       {
         title: 'Student Club Fundraiser',
         details: 'Student hosted event to raise money for club',
         date: '2019-03-31',
         people: '80',
         open: false
       },
       {
         title: 'Award Ceremony',
         details: 'Department teaching and research award reception',
         date: '2019-04-01',
         people: '100',
         open: false
       },
       {
         title: 'Georgia Tech Foundation Gala',
         details: 'Fundraising event for the GT Foundation',
         date: '2019-03-07',
         people: '150',
         open: false
       },
       {
         title: 'Research Meetings with Sponsors',
         details: 'Organizations who sponsor research receive presentations on projects',
         date: '2019-03-03',
         people: '25',
         open: false
       },
       {
         title: 'Grad Student Appreciation',
         details: 'Reception for grad students and their advisors',
         date: '2019-03-01',
         people: '75',
         open: false
       },
       {
         title: 'Conference',
         details: 'Small conference for undergraduate research',
         date: '2019-03-21',
         people: '250',
         open: false
       },
       {
         title: 'Hackathon',
         details: 'Code like there is no tommorrow',
         date: '2019-03-01',
         people: '100',
         open: false
       },
       {
         title: 'Hackathon',
         details: 'Code like there is no tomorrow',
         date: '2019-03-02',
         people: '100',
         open: false
       }
     ],
    technology: {
      //for technology data
      toilet: {
        type: 'High Efficiency',
        efficiency: .01,
      },
      sink: {
        type: 'High Efficiency',
        efficiency: .01,
      }
    },
    skyspark: {
      date: new Date(),
      temp: 'Loading',
      reqPower: 'Loading',
      solarPower: 'Loading',
      yesterdayBuildingLoad: [[new Date('Mon Aug 23 2021 21:00:00'), 0],[new Date('Mon Aug 23 2021 22:00:00'), 0], [new Date('Mon Aug 23 2021 23:00:00'), 0]],
      todayBuildingLoad: [[new Date('Tue Aug 24 2021 00:00:00'), 0],[new Date('Tue Aug 24 2021 01:00:00'), 0], [new Date('Tue Aug 24 2021 02:00:00'), 0]],
      weeklyBuildingLoad: [0,0,0,0,0,0,0],
      yesterdayNetPower: [[new Date('Mon Aug 23 2021 21:00:00'), 0],[new Date('Mon Aug 23 2021 22:00:00'), 0], [new Date('Mon Aug 23 2021 23:00:00'), 0]],
      todayNetPower: [[new Date('Tue Aug 24 2021 00:00:00'), 0],[new Date('Tue Aug 24 2021 01:00:00'), 0], [new Date('Tue Aug 24 2021 02:00:00'), 0]],
      weeklyNetPower: [0,0,0,0,0,0,0],
      netPower: 'Loading',
    },
    DTW: {
      run: 'idle',
      graphType: 'hour',
      start: null,
      end: null,

      general: null,
      lighting: null,
      COP: null,
      HVACsys: null,
      DHWsys: null,
      PVsys: null,

      zone: null,
      envelope: null,
      material: null,

      schedule: null,
      occupation: null,
      operation: null,

      calibration: false,
      calibration_table: null,
    },
    DTW_data: {
      data: null,

      date_time: null,
      pred_Temp: null,
      real_Temp: null,
      pred_HVAC: null,
      real_HVAC: null,
      pred_CCHW: null,
      real_CCHW: null,
      dewP_Temp: null,
      dryB_Temp: null,
      enthalpy: null,
      typeBehavior: null,

      PVgen: null,
      cchw_kW: null,
      plug_kW: null,
      lighting_kW: null,
      dwh_kW: null,
      special_kW: null,
    },
  },
  mutations: {
    changeDates(state,dataZoomOption){
      state.startDateInd = dataZoomOption.dataZoom[0].startValue;
      state.endDateInd = dataZoomOption.dataZoom[0].endValue;
      state.startDate = dataZoomOption.xAxis[0].data[dataZoomOption.dataZoom[0].startValue];
      state.endDate = dataZoomOption.xAxis[0].data[dataZoomOption.dataZoom[0].endValue];
    },
    changeTimes(state,selectedTimes){
      state.selectedTimes = selectedTimes;
    },
    changeDataLoopOption(state){
      state.dataLoopOption = !state.dataLoopOption;
    },
    changeCisternSize(state,cisternObject){
      // console.log(cisternObject)
      state.water.cisternCapacity = cisternObject.value*1000;
    },
    changeToiletType(state,toiletObject){
      state.water.toilet = toiletObject.value.text;
      state.water.kFactors.toilets = toiletObject.efficiency/0.04;
    },
    changeFaucetType(state,faucetObject){
      // console.log(faucetObject)
      state.water.faucet = faucetObject.value.text;
      state.water.kFactors.faucets = faucetObject.efficiency/0.09;
    },
    changeSolarArraySize(state,solarArrayObject){
      state.energy.solarArraySize = solarArrayObject.value;
      // account for size and efficiency degradation
      let degradationRate = 0.005; //0.5% year to year
      let compoundedDegradation = 1;
      // console.log(state.weather.baseYear)
      if (state.weather.baseYear > 2017){
        compoundedDegradation = (1-degradationRate)^(state.weather.baseYear - 2017);
        // console.log(compoundedDegradation)
      }
      // console.log(compoundedDegradation)
      // console.log(state.energy.baselineSolarArraySize)
      state.energy.kFactors.solarArraySize = compoundedDegradation*(solarArrayObject.value/state.energy.baselineSolarArraySize);
    },
    changeLightbulbType(state,lightbulbObject){
      // console.log(lightbulbObject)
      state.energy.lightbulb = lightbulbObject.value.text;
      state.energy.kFactors.lightbulb = lightbulbObject.value.value/9.5;
    },
    changeHVACType(state,hvacObject){
      // console.log(hvacObject)
    },
    changeWindowType(state,windowObject){
      // console.log(windowObject)
      state.energy.window = windowObject.value.text;
      state.energy.kFactors.window = windowObject.efficiency/100;
    },
    changeLocation(state,location){
      state.building.location = location;
    },
    changeBaseYear(state,baseYear){
      state.weather.baseYear = baseYear;
    },
    changeUsage(state,usageObject){
      state.building.usage = usageObject.value;
    },
    changeBuildingType(state,buildingTypeBaselineSolarPower){
      let buildingType = buildingTypeBaselineSolarPower[0];
      let baselineSolarPower = buildingTypeBaselineSolarPower[1];
      state.building.buildingType = buildingType;
      state.energy.baselineSolarArraySize = baselineSolarPower;
      // console.log(state.energy.baselineSolarArraySize)
    },
    changeGrossArea(state,grossArea){
      state.building.grossArea = grossArea;
    },
    updateKBDate(state,date){
      state.skyspark.date = date;
    },
    updateKBTemp(state,temp){
      state.skyspark.temp = temp;
    },
    updateKBReqPower(state,reqPower){
      state.skyspark.reqPower = reqPower;
    },
    updateKBSolarPower(state,solarPower){
      state.skyspark.solarPower = solarPower;
    },
    updateKBWeeklyBuildingLoad(state,weeklyBuildingLoad){
      state.skyspark.weeklyBuildingLoad = weeklyBuildingLoad;
    },
    updateKBWeeklyNetPower(state,weeklyNetPower){
      state.skyspark.weeklyNetPower = weeklyNetPower;
    },
    updateKBNetPower(state,netPower){
      state.skyspark.netPower = netPower;
    },
    updateKBYesterdayBuildingLoad(state,yesterdayBuildingLoad){
      state.skyspark.yesterdayBuildingLoad = yesterdayBuildingLoad;
    },
    updateKBTodayBuildingLoad(state,todayBuildingLoad){
      state.skyspark.todayBuildingLoad = todayBuildingLoad;
    },
    updateKBYesterdayNetPower(state,yesterdayNetPower){
      state.skyspark.yesterdayNetPower = yesterdayNetPower;
    },
    updateKBTodayNetPower(state,todayNetPower){
      state.skyspark.todayNetPower = todayNetPower;
    },

    ///////////////////////////////// DTW Stuff /////////////////////////////////////
    updateDTW_run(state, runState){
      state.DTW.run = runState
    },
    updateDTW_calibration(state, calibrate){
      state.DTW.calibration = calibrate
    },
    updateDTW_graphType(state, type){
      state.DTW.graphType = type
    },
    updateDTW_basicParam(state, type){
      state.DTW.general = type[0]
      state.DTW.lighting = type[1]
      state.DTW.COP = type[2]
      state.DTW.HVACsys = type[3]
      state.DTW.DHWsys = type[4]
      state.DTW.PVsys = type[5]
    },
    updateDTW_advParam(state, type){
      state.DTW.zone = type[0]
      state.DTW.envelope = type[1]
      state.DTW.material = type[2]
      state.DTW.schedule = type[3]
      state.DTW.calibration_table = type[4]
    },
    updateDTW_date(state, dateArray){
      state.DTW.start = dateArray[0];
      state.DTW.end = dateArray[1];
    },
    updateDTW_data(state, data) {
      state.DTW_data.data = data;
      //reminder to self that some units must be changed C-> F etc
      state.DTW_data.date_time = Object.values(data.DateTime);
      state.DTW_data.real_Temp = Object.values(data.T_room_act);      
      state.DTW_data.pred_Temp = Object.values(data.T_room);     
      state.DTW_data.real_HVAC = Object.values(data.load_hvac_act);     
      state.DTW_data.pred_HVAC = Object.values(data.load_hvac);    
      state.DTW_data.real_CCHW = Object.values(data.load_cchw_act);     
      state.DTW_data.pred_CCHW = Object.values(data.load_CCHW_tons); 
      state.DTW_data.dewP_Temp = Object.values(data.DewPt);
      state.DTW_data.dryB_Temp = Object.values(data.DryBulb);
      
      state.DTW_data.enthalpy = Object.values(data.enthalpy);
      state.DTW_data.typeBehavior = Object.values(data.typeBehavior);

      state.DTW_data.PVgen = Object.values(data.PVgen);
      state.DTW_data.cchw_kW = Object.values(data.load_CCHW_kW);
      state.DTW_data.plug_kW = Object.values(data.load_plug_act);
      state.DTW_data.lighting_kW = Object.values(data.load_lighting_act);
      state.DTW_data.special_kW = Object.values(data.load_special_act);
      state.DTW_data.dwh_kW = Object.values(data.load_dwh_act);
      //hvac_kW is the same as real_HVAC
    },
  },
  actions: {

  },
  getters: {

  }
})
